export const ReDate=(TimeStamp)=>{
    var myDate = new Date(TimeStamp);
    var date = (myDate.getDate()<10?'0':'')+(myDate.getDate());
    var month = (myDate.getMonth()+1<10?'0':'')+(myDate.getMonth()+1);
    var year = myDate.getFullYear() +543;
    return date+"/"+month+"/"+year;
}

export const DayAdd=(inputDate,addDay)=>{
    var d = new Date(inputDate);
    d.setDate(d.getDate()+addDay);
    let mkMonth=d.getMonth()+1;
    mkMonth=new String(mkMonth);
    if(mkMonth.length === 1){
        mkMonth="0"+mkMonth;
    }
    let mkDay=d.getDate();
    mkDay=new String(mkDay);
    if(mkDay.length === 1){
        mkDay="0"+mkDay;
    }   
    let mkYear=d.getFullYear();
    return mkDay+"/"+mkMonth+"/"+(mkYear+543); // แสดงผลลัพธ์ในรูปแบบ วัน/เดือน/ปี    
}